export enum NotificationsActionTypes {
  GET_NOTIFICATIONS = "GET_NOTIFICATIONS",
  GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS",
  GET_NOTIFICATIONS_ERROR = "GET_NOTIFICATIONS_ERROR",

  GET_UNREAD_COUNT = "GET_UNREAD_COUNT",
  GET_UNREAD_COUNT_SUCCESS = "GET_UNREAD_COUNT_SUCCESS",
  GET_UNREAD_COUNT_ERROR = "GET_UNREAD_COUNT_ERROR",

  MARK_AS_READ = "MARK_AS_READ",
  MARK_AS_READ_SUCCESS = "MARK_AS_READ_SUCCESS",
  MARK_AS_READ_ERROR = "MARK_AS_READ_ERROR",

  MARK_ALL_AS_READ = "MARK_ALL_AS_READ",
  MARK_ALL_AS_READ_SUCCESS = "MARK_ALL_AS_READ_SUCCESS",
  MARK_ALL_AS_READ_ERROR = "MARK_ALL_AS_READ_ERROR",

  ADD_NOTIFICATION = "ADD_NOTIFICATION", // For Socket.IO real-time
  REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION",

  CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS",
}
